import { useFormContext } from "react-hook-form";
import { countries } from "../assets/countryLists";

const GeneralMusicData = ({ errors }) => {
  const { register } = useFormContext();
  return (
    <div>
      <div>
        <input
          {...register("title")}
          className={`${errors.title && "inputError"}`}
          placeholder="Title"
        />
        {errors.title && (
          <p className="formErrorText">{errors.title.message}</p>
        )}
      </div>

      <div>
        <input
          {...register("featuredArtiste")}
          className="border p-2 w-full"
          placeholder="Featured Artiste (separate with comma art1, art2...)"
        />
        {errors.featuredArtiste && (
          <p className="formTextError">{errors.featuredArtiste.message}</p>
        )}
      </div>

      <div className="flex gap-2">
        <div className="w-full">
          <h6 className="text-sm text-gray-400 ml-1 -mb-4 mt-2 p-0 text-left">
            Date Released
          </h6>
          <input
            type="date"
            {...register("releaseDate")}
            className=""
            placeholder="Released Date"
          />
        </div>
        <div className="w-full">
          <h6 className="text-sm text-gray-400 ml-1 -mb-4 mt-2 p-0 text-left">
            Production Country
          </h6>
          <select {...register("country")} className="">
            <option value="">Select Country</option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex gap-2">
        <div className="w-full">
          <input
            {...register("composer")}
            className={`${errors.composer && "inputError"}`}
            placeholder="Composer"
          />
          {errors.composer && (
            <p className="formErrorText">{errors.composer.message}</p>
          )}
        </div>

        <div className="w-full">
          <input
            {...register("writer")}
            className={`${errors.writer && "inputError"}`}
            placeholder="Writer"
          />
          {errors.writer && (
            <p className="formErrorText">{errors.writer.message}</p>
          )}
        </div>
      </div>

      <div>
        <textarea
          {...register("notes")}
          className={`resize-none h-[120px] ${errors.notes && "inputError"}`}
          placeholder="Enter your music write-ups"
        />
        {errors.notes && (
          <p className="formErrorText">{errors.notes.message}</p>
        )}
      </div>
      <div className="w-full">
        <input
          {...register("genre")}
          className={`${errors.genre && "inputError"}`}
          placeholder="Genres (hiphop blues reggae etc...)"
        />
        {errors.genre && (
          <p className="formErrorText">{errors.genre.message}</p>
        )}
      </div>
    </div>
  );
};

export default GeneralMusicData;
